<!--- Planilha -->

<div class="spreadsheet" *ngIf="pageView === 'spreadsheet'">
	<div class="line" [ngClass]="{ even: index % 2 === 0 }" *ngFor="let line of spreadsheet; let index = index">
		<span class="cell" *ngFor="let cell of line">{{ cell }}</span>
	</div>
</div>

<!-- <div class="config-container" *ngIf="pageView === 'configuration'">
    <cpi-generic-form-gen
    [setGenericForm]="configurationSpreadsheet"
    [labels]="labels"
    [columns]="2">
    </cpi-generic-form-gen>

    <div class="button-container">
        <div class="button" [ngClass]="{'disabled': isSavingConfiguration}" (click)="saveConfiguration()"><span>{{labels.lbl_salvar_colunas}}</span> <cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isSavingConfiguration"></cpi-dot-bounce-loading-effect></div>
    </div>

</div>

<div class="config-button" (click)="goToConfigurationView()" *ngIf="pageView === 'spreadsheet'">
    <fa-icon [icon]="icons.faWrench"></fa-icon>
</div>

<div class="config-button" (click)="goToSpreadsheetView()" *ngIf="pageView === 'configuration'">
    <fa-icon [icon]="icons.faBackward"></fa-icon>
</div>

--->
